import { useState, useRef, useEffect } from 'react';
import { usePhotoGenerate } from '@genfun/core/hooks/usePhotoGenerate';
import { fetchGallery, fetchRemixData } from '@genfun/core/api/API';
import formSchema from '@genfun/core/data/formSchema.json';
import { TapGame } from '../components/TapGame';
import { Footer } from '../components/Footer';
import { downloadFile } from '../utils/download';
import './Generate.css';

const POSE_OPTIONS = [
    { text: "Doggy/twerk",    img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/doggy_twerk.webp",       formRef: { stage1: 0 }, skip: { stage_pose_solo: 0 }, next: "stage_ethnicity_solo" },
    { text: "Standing Glamur", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/standing_glomour_2.webp", formRef: { stage1: 0 }, skip: { stage_pose_solo: 1 }, next: "stage_ethnicity_solo" },
    { text: "SideCurve",      img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/side_curve.webp",        formRef: { stage1: 0 }, skip: { stage_pose_solo: 2 }, next: "stage_ethnicity_solo" },
    { text: "Selfie",         img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/selfie.webp",            formRef: { stage1: 0 }, skip: { stage_pose_solo: 3 }, next: "stage_ethnicity_solo" },
    { text: "KneesFrog",      img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/knees_frog.webp",        formRef: { stage1: 0 }, skip: { stage_pose_solo: 4 }, next: "stage_ethnicity_solo" },
    { text: "BendOverTease",   img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/bend_over_tease.webp",   formRef: { stage1: 0 }, skip: { stage_pose_solo: 5 }, next: "stage_ethnicity_solo" },
    { text: "Showing pussy",   img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/showing_pussy.webp",     formRef: { stage1: 0 }, skip: { stage_pose_solo: 6 }, next: "stage_ethnicity_solo" },
    { text: "Spread legs",     img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/spread_legs.webp",       formRef: { stage1: 1, stage_classic: 1 }, skip: {}, next: "stage_ethnicity_spread_legs" },
    { text: "Gangbang",        img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/gang_bang.webp",          formRef: { stage1: 1, stage_classic: 4 }, skip: {}, next: "stage_ethnicity_gangbang" },
    { text: "Reverse cowgirl", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/reverse_cow_girl.webp",  formRef: { stage1: 1, stage_classic: 5 }, skip: {}, next: "stage_ethnicity_reverse_cowgirl" },
    { text: "Blowjob",        img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/blow_job.webp",           formRef: { stage1: 2, stage_bjs: 0 }, skip: {}, next: "stage_ethnicity_blowjob" },
    { text: "POV cumshot",     img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/pose/cumshot.webp",            formRef: { stage1: 2, stage_bjs: 2 }, skip: {}, next: "stage_ethnicity_cumshot_pov" },
];

const CLOTHES_IMAGES = {
    'Gold chain': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/gold_chain.webp',
    'NUDE': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/nude.webp',
    'School': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/school.webp',
    'Cheerleader': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/cheerleader.webp',
    'Flight attendat': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/flight.webp',
    'Nurse': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/nurse.webp',
    'Police': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/police.webp',
    'Denim shorts': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/denim_shorts.webp',
    'Micro bikini': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/micro_bikini.webp',
    'Kimono': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/kimono.webp',
    'BDSM': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/bdsm.webp',
    'Pink lingerie': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/pink_lingerie.webp',
    'Mini dress': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/clothes/mini_dress.webp',
};

const LOCATION_IMAGES = {
    'Sofa': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/sofa.webp',
    'Island': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/island_.webp',
    'Medium apart': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/abonden_apart.webp',
    'Church': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/church.webp',
    'Sauna': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/sauna.webp',
    'American diner': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/american_diner.webp',
    'Pirate ship': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/pirate_ship.webp',
    'Japanese pool': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/japanese_pool.webp',
    'City View': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/city_view.webp',
    'Winter': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/winter.webp',
    'New York street': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/new_york.webp',
    'Desert': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/desert.webp',
    'London street': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/london_street.webp',
    'School': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/school_location.webp',
    'Great Wall of China': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/great_wall.webp',
    'Yacht': 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/location/yacht_.webp',
};

const CLOTHES_OPTIONS = formSchema.stage_clothes_solo.options;
const LOCATION_OPTIONS = formSchema.stage_location_solo.options;

const POSE_PREVIEWS = [POSE_OPTIONS[1].img, POSE_OPTIONS[2].img, POSE_OPTIONS[10].img];
const CLOTHES_PREVIEWS = [CLOTHES_IMAGES['NUDE'], CLOTHES_IMAGES['Cheerleader'], CLOTHES_IMAGES['Mini dress']];
const LOCATION_PREVIEWS = [LOCATION_IMAGES['Sofa'], LOCATION_IMAGES['City View'], LOCATION_IMAGES['Sauna']];


export const GIRL_PRESETS = [
    { name: "Insta Bimbo", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/insta_bimbo.webp", values: { ethnicity: "scandinavian", girl_type: "insta", hair: "blonde", hair_style: "long", body_type: "perfect", breast_size: "medium", age: "20" } },
    { name: "Harley Quinn", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/harley.webp", values: { ethnicity: "european", girl_type: "harley_quinn", hair: "pink", hair_style: "braids", body_type: "perfect", breast_size: "medium", age: "20" } },
    { name: "Arab Insta", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/arab.webp", values: { ethnicity: "arab", girl_type: "insta_arab", hair: "black", hair_style: "curls", body_type: "chubby", breast_size: "large", age: "30" } },
    { name: "Tattoo GOT", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/tattoo+got.webp", values: { ethnicity: "european", girl_type: "tatto_got", hair: "black", hair_style: "auto", body_type: "skinny", breast_size: "small", age: "18" } },
    { name: "Cute Nerd", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/cute_nerd.webp", values: { ethnicity: "european", girl_type: "a_nerd", hair: "brunette", hair_style: "braids", body_type: "perfect", breast_size: "medium", age: "18" } },
    { name: "Ginger Insta", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/ginger_insta.webp", values: { ethnicity: "european", girl_type: "insta", hair: "ginger", hair_style: "long", body_type: "perfect", breast_size: "medium", age: "20" } },
    { name: "Slavic Blonde", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/slavic.webp", values: { ethnicity: "slavic", girl_type: "woman", hair: "blonde", hair_style: "long", body_type: "perfect", breast_size: "large", age: "20" } },
    { name: "Asian Insta", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/asian_insta.webp", values: { ethnicity: "asian", girl_type: "asian_insta", hair: "pink", hair_style: "curls", body_type: "perfect", breast_size: "medium", age: "20" } },
    { name: "Asian Tattoo", img: "https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode/preset/asian_tattoo.webp", values: { ethnicity: "asian", girl_type: "asian_tatoo", hair: "black", hair_style: "braids", body_type: "perfect", breast_size: "medium", age: "20" } },
];

function isPresetCompatible(preset, pose) {
    let nextName = pose.next;
    while (nextName && nextName !== 'generate') {
        if (nextName.startsWith('stage_clothes_') || nextName.startsWith('stage_location_')) {
            nextName = formSchema[nextName]?.options[0]?.next; continue;
        }
        if (nextName in (pose.skip || {})) {
            nextName = formSchema[nextName]?.options[pose.skip[nextName]]?.next; continue;
        }
        const stage = formSchema[nextName];
        if (!stage) return false;
        const promptKey = Object.keys(stage.options[0]?.data?.prompt || {})[0];
        if (promptKey && preset.values[promptKey] !== undefined) {
            const idx = findOptionIndex(stage, promptKey, preset.values[promptKey]);
            if (idx < 0) return false;
            nextName = stage.options[idx].next;
        } else { return false; }
    }
    return true;
}

function findOptionIndex(stage, promptKey, promptValue) {
    const idx = stage.options.findIndex(opt => opt.data?.prompt?.[promptKey] === promptValue);
    if (idx >= 0) return idx;
    const simplify = v => v.replace(/(.)\1+/g, '$1');
    return stage.options.findIndex(opt => {
        const val = opt.data?.prompt?.[promptKey];
        return val && simplify(val) === simplify(promptValue);
    });
}

function OptionGrid({ options, selected, onSelect, imageMap }) {
    const hasImages = imageMap || options.some(o => o.img);
    return (
        <div className={`optionGrid${hasImages ? ' optionGrid--images' : ''}`}>
            {options.map((opt, idx) => {
                const imgSrc = opt.img || (imageMap && imageMap[opt.text]);
                return (
                    <button key={idx} className={`optionBtn${selected === idx ? ' selected' : ''}${imgSrc ? ' optionBtn--img' : ''}`} onClick={() => onSelect(idx)}>
                        {imgSrc && <img className="optionBtnImg" src={imgSrc} alt="" loading="lazy" />}
                        <span className="optionBtnText">{opt.text}</span>
                    </button>
                );
            })}
        </div>
    );
}

function PickerCard({ label, selectedText, selectedImg, previewImgs, variantCount, variantLabel, onClick, size }) {
    const hasImg = Boolean(selectedText && selectedImg);
    const imgKey = selectedImg || 'empty';
    const textKey = selectedText || 'empty';
    return (
        <button className={`pickerCard pickerCard--${size}${selectedText ? ' picked' : ' empty'}${hasImg ? ' hasImg' : ''}`} onClick={onClick}>
            {!hasImg && previewImgs && (
                <>
                    <span className="pickerCardPreviewLayer" aria-hidden="true">
                        {previewImgs.map((src, i) => (
                            <img key={i} className="pickerCardPreviewImg" src={src} alt="" style={{ animationDelay: `${i * -4}s` }} />
                        ))}
                        <span className="pickerCardAccentWash" />
                    </span>
                </>
            )}
            {hasImg && <img className="pickerCardBackdrop" src={selectedImg} alt="" key={`bd-${imgKey}`} aria-hidden="true" />}
            {hasImg && <span className="pickerCardVignette" />}
            {hasImg ? (
                <>
                    <span className="pickerCardLabel">{label}</span>
                    <img className="pickerCardThumb" src={selectedImg} alt="" key={`th-${imgKey}`} />
                    <span className="pickerCardValue pickerCardValue--onImg" key={`vl-${textKey}`}>{selectedText}</span>
                </>
            ) : (
                <>
                    <span className="pickerCardPeekWrap" aria-hidden="true">
                        {previewImgs && previewImgs.map((src, i) => (
                            <img key={i} className="pickerCardPeek" src={src} alt="" style={{ animationDelay: `${i * -4}s` }} />
                        ))}
                    </span>
                    <span className="pickerCardTitle">{label}</span>
                    <span className="pickerCardCta">
                        <span className="pickerCardCount">{variantCount} {variantLabel}</span>
                        <span className="pickerCardCtaDot">·</span>
                        <span className="pickerCardCtaAction">Tap to choose</span>
                        <span className="pickerCardCtaArrow">›</span>
                    </span>
                </>
            )}
        </button>
    );
}

function useLockBodyScroll(isOpen) {
    useEffect(() => {
        if (!isOpen) return;
        const html = document.documentElement;
        const body = document.body;
        const scrollbarWidth = window.innerWidth - html.clientWidth;
        const prev = {
            bodyOverflow: body.style.overflow,
            htmlOverflow: html.style.overflow,
            bodyPaddingRight: body.style.paddingRight,
        };
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
        return () => {
            body.style.overflow = prev.bodyOverflow;
            html.style.overflow = prev.htmlOverflow;
            body.style.paddingRight = prev.bodyPaddingRight;
        };
    }, [isOpen]);
}

function Popup({ isOpen, onClose, title, children }) {
    useLockBodyScroll(isOpen);
    if (!isOpen) return null;
    return (
        <div className="popupOverlay" onClick={onClose}>
            <div className="popupContent" onClick={e => e.stopPropagation()}>
                <div className="popupHeader">
                    <span className="popupTitle">{title}</span>
                    <button className="popupClose" onClick={onClose}>&times;</button>
                </div>
                <div className="popupBody">{children}</div>
            </div>
        </div>
    );
}

function ControlRow({ label, options, selected, onSelect }) {
    return (
        <div className="controlRow">
            <div className="controlLabel">{label}</div>
            <div className="controlButtons">
                {options.map((opt, idx) => (
                    <button key={idx} className={`controlBtn${selected === idx ? ' selected' : ''}`} onClick={() => onSelect(idx)}>
                        {opt.icon && <span className="controlBtnIcon">{opt.icon}</span>}
                        {opt.text}
                    </button>
                ))}
            </div>
        </div>
    );
}

const GEN_MESSAGES = ['Creating magic', 'Building your vision', 'Polishing details', 'Almost there'];

function ProgressBar({ durationMs, startTime }) {
    const [progress, setProgress] = useState(0);
    const [msgIdx, setMsgIdx] = useState(0);
    const startRef = useRef(startTime || Date.now());
    useEffect(() => {
        const interval = setInterval(() => {
            const elapsed = Date.now() - startRef.current;
            setProgress(Math.min(95, (elapsed / durationMs) * 100));
        }, 300);
        return () => clearInterval(interval);
    }, [durationMs]);
    useEffect(() => {
        const interval = setInterval(() => {
            setMsgIdx(i => (i + 1) % GEN_MESSAGES.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);
    const secsLeft = Math.max(0, Math.round((durationMs - (Date.now() - startRef.current)) / 1000));
    return (
        <div className="progressWrap">
            <div className="progressBar" style={{ width: `${progress}%` }} />
            <div className="progressText">{GEN_MESSAGES[msgIdx]}...</div>
            <div className="progressTime">~{secsLeft}s remaining</div>
        </div>
    );
}

function LoadingSection({ durationMs, isVideo }) {
    const [startTime] = useState(() => Date.now());
    const progressRef = useRef(null);
    const onGameDone = () => {
        progressRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    return (
        <div className="loadingSection">
            <div className="loadingBigTitle">
                <div className="loadingBigTitleMain">While you wait</div>
                <div className="loadingBigTitleSub">Play the tap game below</div>
            </div>
            <div ref={progressRef} style={{ width: '100%' }}>
                <ProgressBar durationMs={durationMs} startTime={startTime} />
            </div>
            <TapGame isVideo={isVideo} durationMs={durationMs} onDone={onGameDone} />
        </div>
    );
}

function ReportFlagIcon() {
    return (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
            <line x1="4" y1="22" x2="4" y2="15"/>
        </svg>
    );
}

function Lightbox({ item, token, onClose, onReport }) {
    useLockBodyScroll(true);
    const [displayUrl, setDisplayUrl] = useState(item.url);
    const [fullUrl, setFullUrl] = useState(item.is_video ? item.url : null);

    useEffect(() => {
        if (item.is_video) { setFullUrl(item.url); return; }
        if (!item.media_id || !token) { setFullUrl(item.url); return; }
        let cancelled = false;
        fetchRemixData(token, item.media_id).then(data => {
            const url = data?.url || item.url;
            if (cancelled) return;
            const preload = new Image();
            preload.onload = () => { if (!cancelled) setDisplayUrl(url); };
            preload.onerror = () => { if (!cancelled) setDisplayUrl(url); };
            preload.src = url;
            setFullUrl(url);
        }).catch(() => { if (!cancelled) setFullUrl(item.url); });
        return () => { cancelled = true; };
    }, [item.media_id, token, item.is_video, item.url]);

    return (
        <div className="lightboxOverlay" onClick={onClose}>
            <div className="lightboxContent" onClick={e => e.stopPropagation()}>
                <button className="lightboxClose" onClick={onClose}>&times;</button>
                {item.is_video ? (
                    <video className="lightboxMedia" src={item.url} autoPlay loop muted playsInline controls />
                ) : (
                    <img className="lightboxMedia" src={displayUrl} alt="" />
                )}
                <div className="lightboxActions">
                    {fullUrl && (
                        <button type="button" className="lightboxDownload" onClick={() => downloadFile(fullUrl)}>
                            Download
                        </button>
                    )}
                    {item.media_id && onReport && (
                        <button type="button" className="mediaReportBtn" onClick={() => onReport(item.media_id)}>
                            <ReportFlagIcon />
                            Report content
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export function Generate({ token, user, setSignedIn, onNavigate, onReport, setShowLogin, setShowPricing, subStatus }) {
    const [img, setImg] = useState(null);
    const [video, setVideo] = useState(null);
    const [genType, setGenType] = useState(null);
    const [generated, setGenerated] = useState(false);
    const [taskId, setTaskId] = useState(null);

    const [selectedPose, setSelectedPose] = useState(null);
    const [selectedClothes, setSelectedClothes] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [openPopup, setOpenPopup] = useState(null); // 'pose'|'clothes'|'location'|null

    const [phase, setPhase] = useState('pick'); // 'pick' | 'choose' | 'girl' | 'generate'
    const [girlStages, setGirlStages] = useState([]);
    const [girlSelections, setGirlSelections] = useState({});
    const [girlName, setGirlName] = useState(null);

    const [gallery, setGallery] = useState([]);
    const [showGallery, setShowGallery] = useState(false);
    const [lightboxItem, setLightboxItem] = useState(null);

    const formRef = useRef({ type: 'photo', number: 1 });
    const resultRef = useRef(null);

    // Fetch user gallery
    useEffect(() => {
        if (!token) return;
        fetchGallery([], 0, false, token, false, false, true, 200).then(data => {
            if (data?.content && Array.isArray(data.content)) setGallery(data.content);
        }).catch(() => {});
    }, [token, generated]);

    const { handleGenerate, error } = usePhotoGenerate({
        token, formRef, textPromptActive: false, textPromptValue: '',
        callbacks: {
            setGenType, setGenerated, setImg, setVideo, setTaskId,
            setAnimateAction: () => {}, setGenerationConfig: () => {},
            setShowVideoPopUp: () => {}, setShowPayPopUp: () => {},
            onScrollToResults: () => resultRef.current?.scrollIntoView({ behavior: 'smooth' }),
            onResetInteraction: () => {},
        }
    });

    const phase1Ready = selectedPose !== null && selectedClothes !== null && selectedLocation !== null;

    const initFormRef = () => {
        const pose = POSE_OPTIONS[selectedPose];
        Object.keys(formRef.current).forEach(k => { if (k.startsWith('stage')) delete formRef.current[k]; });
        Object.assign(formRef.current, pose.formRef);
        for (const [stageName, idx] of Object.entries(pose.skip)) formRef.current[stageName] = idx;
    };

    const handleChooseGirl = () => {
        initFormRef();
        const firstStage = formSchema[POSE_OPTIONS[selectedPose].next];
        if (firstStage) { setGirlStages([firstStage]); setGirlSelections({}); setGirlName('Custom'); setPhase('girl'); }
    };

    const handlePreset = (preset) => {
        initFormRef();
        const pose = POSE_OPTIONS[selectedPose];
        let nextName = pose.next;
        while (nextName && nextName !== 'generate') {
            if (nextName.startsWith('stage_clothes_')) { formRef.current[nextName] = selectedClothes; nextName = formSchema[nextName]?.options[selectedClothes]?.next; continue; }
            if (nextName.startsWith('stage_location_')) { formRef.current[nextName] = selectedLocation; nextName = formSchema[nextName]?.options[selectedLocation]?.next; continue; }
            if (nextName in (pose.skip || {})) { const si = pose.skip[nextName]; formRef.current[nextName] = si; nextName = formSchema[nextName]?.options[si]?.next; continue; }
            const stage = formSchema[nextName];
            if (!stage) break;
            const pk = Object.keys(stage.options[0]?.data?.prompt || {})[0];
            if (pk && preset.values[pk] !== undefined) {
                const idx = findOptionIndex(stage, pk, preset.values[pk]);
                if (idx >= 0) { formRef.current[nextName] = idx; nextName = stage.options[idx].next; continue; }
            }
            break;
        }
        setGirlStages([]); setGirlSelections({}); setGirlName(preset.name); setPhase('generate');
    };

    const handleGirlSelect = (stageIndex, optionIndex) => {
        const stage = girlStages[stageIndex];
        const option = stage.options[optionIndex];
        formRef.current[stage.name] = optionIndex;
        const newSelections = { ...girlSelections, [stage.name]: optionIndex };
        const newStages = girlStages.slice(0, stageIndex + 1);
        girlStages.slice(stageIndex + 1).forEach(s => { delete formRef.current[s.name]; delete newSelections[s.name]; });

        let nextName = option.next;
        while (nextName && nextName !== 'generate') {
            if (nextName.startsWith('stage_clothes_')) { formRef.current[nextName] = selectedClothes; nextName = formSchema[nextName]?.options[selectedClothes]?.next; continue; }
            if (nextName.startsWith('stage_location_')) { formRef.current[nextName] = selectedLocation; nextName = formSchema[nextName]?.options[selectedLocation]?.next; continue; }
            if (nextName in (POSE_OPTIONS[selectedPose]?.skip || {})) { const si = POSE_OPTIONS[selectedPose].skip[nextName]; formRef.current[nextName] = si; nextName = formSchema[nextName]?.options[si]?.next; continue; }
            const nextStage = formSchema[nextName];
            if (nextStage) { newStages.push(nextStage); setGirlStages(newStages); setGirlSelections(newSelections); return; }
            break;
        }
        setGirlStages(newStages); setGirlSelections(newSelections); setPhase('generate');
    };

    const handleBack = () => {
        if (phase === 'girl' || phase === 'generate') { setPhase('choose'); setGirlStages([]); setGirlSelections({}); setGirlName(null); }
        else { setPhase('pick'); }
    };

    const onGenerate = () => {
        if (!user) { setShowLogin(true); return; }
        if (subStatus !== 'active') { setShowPricing(true); return; }
        handleGenerate();
    };


    const handleCreateNew = () => {
        setPhase('pick');
        setSelectedPose(null);
        setSelectedClothes(null);
        setSelectedLocation(null);
        setGirlStages([]);
        setGirlSelections({});
        setGirlName(null);
        setImg(null);
        setVideo(null);
        setGenerated(false);
        setGenType(null);
        formRef.current = { type: 'photo', number: 1 };
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const images = img ? (Array.isArray(img) ? img : [img]) : [];
    const showLoading = !!genType && !generated;
    const showResult = images.length > 0 || !!video;

    return (
        <div className="genPage">

            {/* Phase 1: Picker cards */}
            {phase === 'pick' && (
                <div className="genPickerSection">
                    <section className="genHero">
                        <span className="genHeroPill">AI Photo Generator</span>
                        <h1 className="genHeroTitle">
                            Create your <span className="genHeroTitleAccent">dream photo</span>
                        </h1>
                        <p className="genHeroSubtitle">Pick pose · clothes · location</p>
                    </section>

                    <div className="genStepHeader">
                        <span className="genEyebrow">Compose the shot</span>
                    </div>

                    <div className="genPickerCards">
                        <PickerCard
                            label="Pose"
                            selectedText={selectedPose !== null ? POSE_OPTIONS[selectedPose].text : null}
                            selectedImg={selectedPose !== null ? POSE_OPTIONS[selectedPose].img : null}
                            previewImgs={POSE_PREVIEWS}
                            variantCount={POSE_OPTIONS.length}
                            variantLabel="poses"
                            onClick={() => setOpenPopup('pose')}
                            size="tall"
                        />
                        <div className="genPickerRight">
                            <PickerCard
                                label="Clothes"
                                selectedText={selectedClothes !== null ? CLOTHES_OPTIONS[selectedClothes].text : null}
                                selectedImg={selectedClothes !== null ? CLOTHES_IMAGES[CLOTHES_OPTIONS[selectedClothes].text] : null}
                                previewImgs={CLOTHES_PREVIEWS}
                                variantCount={CLOTHES_OPTIONS.length}
                                variantLabel="styles"
                                onClick={() => setOpenPopup('clothes')}
                                size="square"
                            />
                            <PickerCard
                                label="Location"
                                selectedText={selectedLocation !== null ? LOCATION_OPTIONS[selectedLocation].text : null}
                                selectedImg={selectedLocation !== null ? LOCATION_IMAGES[LOCATION_OPTIONS[selectedLocation].text] : null}
                                previewImgs={LOCATION_PREVIEWS}
                                variantCount={LOCATION_OPTIONS.length}
                                variantLabel="places"
                                onClick={() => setOpenPopup('location')}
                                size="square"
                            />
                        </div>
                    </div>

                    <button className="chooseGirlBtn" onClick={() => {
                        if (!user) { setShowLogin(true); return; }
                        if (subStatus !== 'active') { setShowPricing(true); return; }
                        if (!phase1Ready) return;
                        setPhase('choose');
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}>
                        <svg className="chooseGirlIcon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="12" y1="5" x2="12" y2="19" />
                            <line x1="5" y1="12" x2="19" y2="12" />
                        </svg>
                        <span>Create girl</span>
                    </button>
                </div>
            )}

            {/* Phase 1.5: Choose girl (compact summary + presets) */}
            {phase === 'choose' && (
                <div className="genGirlSection">
                    <div className="genSummaryBar">
                        <button className="backBtn" onClick={handleBack}>Back</button>
                        <div className="genSummaryItems">
                            <span className="summaryTag">{POSE_OPTIONS[selectedPose]?.text}</span>
                            <span className="summaryDot">/</span>
                            <span className="summaryTag">{CLOTHES_OPTIONS[selectedClothes]?.text}</span>
                            <span className="summaryDot">/</span>
                            <span className="summaryTag">{LOCATION_OPTIONS[selectedLocation]?.text}</span>
                        </div>
                    </div>
                    <div className="genChooseSection">
                        <button className="customizeGirlBtn" onClick={() => { if (!user) { setShowLogin(true); return; } if (subStatus !== 'active') { setShowPricing(true); return; } handleChooseGirl(); }}>
                            <span className="customizeGirlIcon">✨</span>
                            <span className="customizeGirlText">Customize girl</span>
                            <span className="customizeGirlHint">Choose ethnicity, hair, body type and more</span>
                        </button>
                        {(() => {
                            const available = GIRL_PRESETS.filter(p => isPresetCompatible(p, POSE_OPTIONS[selectedPose]));
                            if (!available.length) return null;
                            return (
                                <div className="presetSection">
                                    <div className="presetLabel">Or pick a girl</div>
                                    <div className="presetGrid--images">
                                        {available.map((preset, idx) => (
                                            <button key={idx} className="presetBtn--img" onClick={() => { if (!user) { setShowLogin(true); return; } if (subStatus !== 'active') { setShowPricing(true); return; } handlePreset(preset); }}>
                                                <img className="presetBtnImg" src={preset.img} alt="" loading="lazy" />
                                                <span className="presetBtnText">{preset.name}</span>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            );
                        })()}
                    </div>
                </div>
            )}

            {/* Phase 2: Girl selection */}
            {(phase === 'girl' || phase === 'generate') && (
                <div className="genGirlSection">
                    <div className="genSummaryBar">
                        <button className="backBtn" onClick={handleBack}>Back</button>
                        <div className="genSummaryItems">
                            <span className="summaryTag">{POSE_OPTIONS[selectedPose]?.text}</span>
                            <span className="summaryDot">/</span>
                            <span className="summaryTag">{CLOTHES_OPTIONS[selectedClothes]?.text}</span>
                            <span className="summaryDot">/</span>
                            <span className="summaryTag">{LOCATION_OPTIONS[selectedLocation]?.text}</span>
                            {girlName && (
                                <>
                                    <span className="summaryDot">/</span>
                                    <span className="summaryTag summaryTagGirl">👩 {girlName}</span>
                                </>
                            )}
                        </div>
                    </div>

                    {girlStages.map((stage, idx) => (
                        <ControlRow
                            key={stage.name} label={stage.header} options={stage.options}
                            selected={girlSelections[stage.name] ?? formRef.current[stage.name]}
                            onSelect={(optIdx) => handleGirlSelect(idx, optIdx)}
                        />
                    ))}

                    {phase === 'generate' && !generated && (
                        <button className="generateBtn" onClick={onGenerate} disabled={showLoading}>
                            {showLoading ? 'Generating...' : 'Generate'}
                        </button>
                    )}
                    {generated && (
                        <button className="generateBtn" onClick={handleCreateNew}>
                            Create new
                        </button>
                    )}
                </div>
            )}

            {/* Result area */}
            <div ref={resultRef} />
            {(showLoading || showResult || error) && (
                <div className="genResultSection">
                    {showLoading && <LoadingSection durationMs={80000} />}
                    {!showLoading && showResult && (
                        <>
                            {images.length > 0
                                ? <img className="resultImg" src={images[0]} alt="Generated" />
                                : <video className="resultImg" src={video} autoPlay loop muted playsInline />
                            }
                            <div className="resultActions">
                                <button
                                    type="button"
                                    className="downloadBtn"
                                    onClick={() => downloadFile(images.length > 0 ? images[0] : video)}
                                >
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                    Download
                                </button>
                                {taskId && onReport && (
                                    <button type="button" className="mediaReportBtn" onClick={() => onReport(taskId)}>
                                        <ReportFlagIcon />
                                        Report content
                                    </button>
                                )}
                            </div>
                        </>
                    )}
                    {error && <div className="genError">{error}</div>}
                </div>
            )}

            {/* Gallery */}
            <div className="genGallerySection">
                {!showGallery ? (
                    <button className="galleryToggleBtn" onClick={() => setShowGallery(true)}>
                        <span className="galleryToggleIcon">📸</span>
                        <span className="galleryToggleText">
                            {gallery.length > 0 ? `Your generations (${gallery.length})` : 'Your generations'}
                        </span>
                        <span className="galleryToggleArrow">↓</span>
                    </button>
                ) : (
                    <>
                        <button className="galleryToggleBtn galleryToggleBtn--open" onClick={() => setShowGallery(false)}>
                            <span className="galleryToggleIcon">📸</span>
                            <span className="galleryToggleText">Your generations</span>
                            <span className="galleryToggleArrow">↑</span>
                        </button>
                        {gallery.length > 0 ? (
                            <div className="galleryGrid">
                                {gallery.map((item, idx) => (
                                    <div key={item.media_id || idx} className="galleryItem" onClick={() => setLightboxItem(item)} style={{ cursor: 'pointer' }}>
                                        {item.is_video ? (
                                            <video className="galleryMedia" src={item.url} muted playsInline loop
                                                onMouseEnter={e => { e.target.play().catch(() => {}); }} onMouseLeave={e => { e.target.pause(); e.target.currentTime = 0; }} />
                                        ) : (
                                            <img className="galleryMedia" src={item.url} alt="" loading="lazy" />
                                        )}
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="galleryEmpty">
                                <span className="galleryEmptyIcon">✨</span>
                                <span className="galleryEmptyText">Your creations will appear here</span>
                            </div>
                        )}
                    </>
                )}
            </div>

            {/* Popups */}
            <Popup isOpen={openPopup === 'pose'} onClose={() => setOpenPopup(null)} title="Choose Pose">
                <OptionGrid options={POSE_OPTIONS} selected={selectedPose}
                    onSelect={(idx) => { setSelectedPose(idx); setOpenPopup(null); }} />
            </Popup>
            <Popup isOpen={openPopup === 'clothes'} onClose={() => setOpenPopup(null)} title="Choose Clothes">
                <OptionGrid options={CLOTHES_OPTIONS} selected={selectedClothes}
                    imageMap={CLOTHES_IMAGES}
                    onSelect={(idx) => { setSelectedClothes(idx); setOpenPopup(null); }} />
            </Popup>
            <Popup isOpen={openPopup === 'location'} onClose={() => setOpenPopup(null)} title="Choose Location">
                <OptionGrid options={LOCATION_OPTIONS} selected={selectedLocation}
                    imageMap={LOCATION_IMAGES}
                    onSelect={(idx) => { setSelectedLocation(idx); setOpenPopup(null); }} />
            </Popup>


            {/* Lightbox */}
            {lightboxItem && (
                <Lightbox item={lightboxItem} token={token} onClose={() => setLightboxItem(null)} onReport={onReport} />
            )}

            <Footer onNavigate={onNavigate} />
        </div>
    );
}
